<template>
  <v-dialog :value="value" persistent max-width="700">
    <d-caja :local="local">
      <v-spacer />
      <v-btn color="secondary" @click="$emit('input', false)">
        cerrar
      </v-btn>
    </d-caja>
  </v-dialog>
</template>

<script>
import Caja from './Caja'

export default {
  components: {
    'd-caja': Caja,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    local: {
      type: Object,
      default: null
    },
  },
};
</script>
